import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useAuth } from '../context/AuthContext';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { MaintenancePage } from './SiteUnavailable';
import AnalyticsTracker from './AnalyticsTracker';
import './Layout.css';

const Layout = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isAdminPanel = location.pathname === '/admin-panel';
  const { user, authLoading } = useAuth();
  const { settings } = useSiteSettings();

  if (settings.status.maintenanceEnabled && authLoading) {
    return <div className="layout-loading" aria-label={t('common.checkingSite')} />;
  }
  if (settings.status.maintenanceEnabled && user?.role !== 'admin') {
    return <MaintenancePage />;
  }

  return (
    <div className="layout">
      <AnalyticsTracker />
      <Navbar />
      <main className={`main-content ${isAdminPanel ? 'admin-main' : ''}`}>
        <Outlet />
      </main>
      {!isAdminPanel && <Footer />}
    </div>
  );
};

export default Layout;
